import DialpadOutlinedIcon from '@mui/icons-material/DialpadOutlined';
import HelpCenterOutlinedIcon from '@mui/icons-material/HelpCenterOutlined';
import LocalPhoneOutlinedIcon from '@mui/icons-material/LocalPhoneOutlined';
import PaymentOutlinedIcon from '@mui/icons-material/PaymentOutlined';
import RecommendOutlinedIcon from '@mui/icons-material/RecommendOutlined';
import React from 'react';

const ClientHubMobileFooter = (props: {
  scrollTo: Function;
  activeSection: string;
  hasGate: boolean;
}) => {
  const { scrollTo, activeSection, hasGate } = props;

  const menuItemStaticStyle: any = {
    height: '80px',
    display: 'flex',
    flexDirection: 'column',
    alignItems: 'center',
    width: hasGate ? '20%' : '25%',
  };

  const menuIconStyle: any = {
    height: '48px',
    lineHeight: '60px',
    fontSize: '50px',
  };

  const menuItemColor = {
    selected: 'rgba(240, 248, 255, 1)',
    default: 'rgba(240, 248, 255, 0.5)',
  };

  const menuItemDynamicStyle = (itemId: string) => {
    return {
      backgroundColor:
        activeSection === itemId
          ? menuItemColor.selected
          : menuItemColor.default,
      boxShadow:
        activeSection === itemId
          ? 'lightblue 0px 0px 24px -16px inset'
          : undefined,
    };
  };
  return (
    <div
      id="mobile-footer"
      className="fixed-bottom"
      style={{
        height: '80px',
        backgroundColor: 'white',
        opacity: 1,
        zIndex: 999,
      }}
    >
      <div
        style={{
          display: 'flex',
          flexDirection: 'row',
          justifyContent: 'space-evenly',
          height: '80px',
        }}
      >
        <div
          onClick={() => scrollTo('contact')}
          style={{ ...menuItemStaticStyle, ...menuItemDynamicStyle('contact') }}
        >
          <div style={menuIconStyle}>
            <LocalPhoneOutlinedIcon />
          </div>
          <div>Contact</div>
        </div>

        <div
          onClick={() => scrollTo('payment')}
          style={{ ...menuItemStaticStyle, ...menuItemDynamicStyle('payment') }}
        >
          <div style={menuIconStyle}>
            <PaymentOutlinedIcon />
          </div>
          <div>Payments</div>
        </div>

        {hasGate && (
          <div
            onClick={() => scrollTo('access')}
            style={{
              ...menuItemStaticStyle,
              ...menuItemDynamicStyle('access'),
            }}
          >
            <div style={menuIconStyle}>
              <DialpadOutlinedIcon />
            </div>
            <div>Access</div>
          </div>
        )}

        <div
          onClick={() => scrollTo('referral')}
          style={{
            ...menuItemStaticStyle,
            ...menuItemDynamicStyle('referral'),
          }}
        >
          <div style={menuIconStyle}>
            <RecommendOutlinedIcon />
          </div>
          <div>Referrals</div>
        </div>

        <div
          onClick={() => scrollTo('faq')}
          style={{ ...menuItemStaticStyle, ...menuItemDynamicStyle('faq') }}
        >
          <div style={menuIconStyle}>
            <HelpCenterOutlinedIcon />
          </div>
          <div>FAQs</div>
        </div>
      </div>
    </div>
  );
};

export default ClientHubMobileFooter;
